<!-- Data loading -->
@if (isLoading || wallets == undefined) {
<div>
  @if (isLoading) {
  <mat-spinner diameter="50"></mat-spinner>
  }
</div>
}

<!-- Main content -->
@if (!isLoading && wallets) {
<div class="settings-tab">
  <!-- View mode (not editing) -->
  @if (!editingBankAccount) {
  <!-- If we have existing wallets -->
  @if (wallets.length > 0) {
  <div class="view-cards">
    @for (wallet of wallets; track wallet) {
    <div class="bank-card">
      <!-- Status Indicator -->
      <div class="status-indicator" [ngClass]="{
                  'status-pending': (wallet.nickname + '').includes('[p]'),
                  'status-active': wallet.active === '1',
                  'status-inactive': wallet.active === '0',
                }">
        {{
        (wallet.nickname + "").includes("[p]")
        ? "Pending"
        : wallet.active === "1"
        ? "Active"
        : "Inactive"
        }}
      </div>
      <!-- Bank Information -->
      <h4 class="bank-name">{{ wallet.bankName }}</h4>
      <h5 class="bank-name">{{ stripPendingTag(wallet.nickname) }}</h5>
      <p class="bank-detail">
        {{ +wallet.accountType === 0 ? "Checking" : "Savings" }} Account
        ending in {{ wallet.accountNumber.slice(-4) }}
      </p>
      <p class="bank-detail">Routing #: {{ wallet.abaNumber }}</p>
      <!-- Card Buttons -->
      <div class="card-buttons">
        <!-- Pending wallets: only show Remove -->
        @if (wallet.nickname.includes("[p]")) {
        <button type="button" class="action-button" color="primary" (click)="removeAccount(wallet.achwalletID)"
          [disabled]="
                      isDeletingWalletId === wallet.achwalletID ||
                      !wallet.achwalletID
                    ">
          @if (isDeletingWalletId === wallet.achwalletID) {
          <mat-spinner diameter="16"></mat-spinner>
          }
          @if (isDeletingWalletId !== wallet.achwalletID) {
          <span>Remove</span>
          }
        </button>
        } @else {
        @if (!wallet.isActive) {
        <button type="button" class="action-button" color="primary" (click)="setAsDefault(wallet.achwalletID)"
          [disabled]="isSubmittingDefaultId === wallet.achwalletID">
          @if (isSubmittingDefaultId === wallet.achwalletID) {
          <mat-spinner diameter="16"></mat-spinner>
          } @else {
          <span>Set as Default</span>
          }
        </button>
        }
        <button type="button" class="action-button" color="primary" (click)="editExisting(wallet)">
          Edit
        </button>
        <button type="button" class="action-button" (click)="removeAccount(wallet.achwalletID)"
          [disabled]="isDeletingWalletId === wallet.achwalletID">
          @if (isDeletingWalletId === wallet.achwalletID) {
          <mat-spinner diameter="16"></mat-spinner>
          }
          @if (isDeletingWalletId !== wallet.achwalletID) {
          <span>Remove</span>
          }
        </button>
        }
        <!-- Active/Inactive wallets: all three actions -->
      </div>
    </div>
    }
  </div>
  }
  <!-- Message when no wallets exist -->
  @if (wallets.length === 0) {
  <div class="no-accounts">
    <p>You have not added a bank account yet.</p>
  </div>
  }
  <!-- Always‑visible Add button -->
  <div class="add-account-container" style="margin-top: 1rem">
    <button mat-raised-button color="primary" (click)="addWallet()">
      Add Bank Account
    </button>
  </div>
  } @else {
  <div class="edit-form-container">
    <!-- Back link -->
    <button type="button" class="back-button" (click)="cancelEditBankAccount()">
      ← Back
    </button>
    <form #bankAccountForm="ngForm" (ngSubmit)="saveBankAccount()">
      <!-- Bank Nickname -->
      <div class="form-group">
        <label for="bankNickname">Bank Nickname</label>
        <input id="bankNickname" name="bankNickname" type="text" class="form-control" required
          [(ngModel)]="activeWallet.bankNickname" #bankNicknameField="ngModel" />
        @if (bankNicknameField.invalid && bankNicknameField.touched) {
        <div class="error">
          {{ errorMsgs.requiredField }}
        </div>
        }
      </div>
      <!-- Account Number -->
      <div class="form-group">
        <label for="accountNumber">Account Number</label>
        <input id="accountNumber" name="accountNumber" type="text" class="form-control" maxlength="17" pattern="^[^*]+$"
          (keypress)="preventInvalidChars($event)" required [(ngModel)]="activeWallet.accountNumber"
          #accountNumberField="ngModel" />
        @if (accountNumberField.invalid && accountNumberField.touched) {
        <div class="error">
          @if (accountNumberField.errors?.["required"]) {
          <span>
            {{ errorMsgs.requiredField }}
          </span>
          }
          @if (accountNumberField.errors?.["pattern"]) {
          <span>
            {{ errorMsgs.asteriskNotAllowed }}
          </span>
          }
        </div>
        }
      </div>
      <!-- Routing Number -->
      <div class="form-group">
        <label for="routingNumber">Routing Number</label>
        <input id="routingNumber" name="routingNumber" type="text" class="form-control" maxlength="9" required
          mask="000000000" [validation]="true" [(ngModel)]="activeWallet.routingNumber" #routingNumberField="ngModel" />
        @if (routingNumberField.invalid && routingNumberField.touched) {
        <div class="error">
          @if (routingNumberField.errors?.["required"]) {
          <span>
            {{ errorMsgs.requiredField }}
          </span>
          }
          @if (routingNumberField.errors?.["mask"]) {
          <span>
            {{ errorMsgs.invalidRoutingNumber }}
          </span>
          }
        </div>
        }
      </div>
      <!-- Account Type -->
      <div class="form-group">
        <label for="accountType">Account Type</label>
        <select id="accountType" name="accountType" class="form-control" required [(ngModel)]="activeWallet.accountType"
          #accountTypeField="ngModel">
          <option [value]="0">Checking</option>
          <option [value]="1">Savings</option>
        </select>
        @if (accountTypeField.invalid && accountTypeField.touched) {
        <div class="error">
          {{ errorMsgs.requiredField }}
        </div>
        }
      </div>
      <!-- Save Button -->
      <div class="button-container">
        <button mat-raised-button type="submit" class="save-button" color="primary"
          [disabled]="bankAccountForm.form.invalid || isSubmitting">
          @if (isSubmitting) {
          <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!isSubmitting) {
          <span>Save</span>
          }
        </button>
      </div>
    </form>
  </div>
  }
  <!-- Edit/Add form -->
</div>
}